import React from "react"

const modalRoot = document.getElementById(`modal-root`)

export default function withModalSetup(WrappedModal) {
  return class extends React.Component {
    state = {
      isModalMounted: false,
    }

    el = document.createElement(`div`)

    componentDidMount() {
      modalRoot.appendChild(this.el)
      this.setState({ isModalMounted: true })
    }

    componentWillUnmount() {
      modalRoot.removeChild(this.el)
    }

    render() {
      const { isModalMounted } = this.state

      return (
        <WrappedModal
          isModalMounted={isModalMounted}
          containerDomNode={this.el}
          {...this.props}
        />
      )
    }
  }
}
